import { getApiClient } from 'adapter/out/client/apiClient';
import Location from 'domain/entity/location';
import ReadLocationsByHierarchyCriteria from 'use-case/locations/read/ReadLocationsByHierarchyCriteria';

const getReadLocationsByHierarchyApiClient = getApiClient((criteria: ReadLocationsByHierarchyCriteria) => {
    const params = new URLSearchParams({
        root_location_id: criteria.locationId,
    });

    return `locations/hierarchy?${params.toString()}`;
}, Location);

export default getReadLocationsByHierarchyApiClient;
